module.exports = __webpack_public_path__ + "img/unactiveGoodsRecommendIcon.b04c01cc.svg";